<template>
  <div class="diversity-driver-table-wrap">
    <nav class="top-nav">
      <ul>
        <li
          v-for="(s,index) in sortByData"
          :key="index"
        >
          <div class="top-menu"
            @click="onClickSortBy(index , s)"
            :class="activeSort === index ? 'top-menu--active' : ''"
          >
            <div class="top-menu__title"> {{s}} </div>
          </div>
        </li>
      </ul>
    </nav>
    <div class="nav-body">
      <table class="am-table">
        <thead class="am-head">
          <tr class="header-row">
            <th scope="col">&nbsp;</th>
            <th
              v-for="(h,key) in tableHeader"
              :key="key"
              scope="col"
            >{{h}}</th>
            <!-- <th scope="col">Overall</th>
            <th scope="col">Carrer Opportunities</th>
            <th scope="col">Culture</th>
            <th scope="col">Leadership</th>
            <th scope="col">Performance Management</th>
            <th scope="col">Rewards and Recognition</th>
            <th scope="col">Worklife Integration</th> -->
          </tr>
          <tr class="sub-header-row">
            <th scope="col" class="text-left">{{sortByItem}}</th>
            <!-- <th scope="col">
              <tr class="sub-header">
                <td>Male</td>
                <td>Female</td>
                <td>Others</td>
              </tr>
            </th> -->
            <th scope="col" v-if="tableHeader.length > 0">
              <tr class="sub-header">
                <td>Male</td>
                <td>Female</td>
                <td>Others</td>
              </tr>
            </th>
            <th scope="col" v-if="tableHeader.length > 1">
              <tr class="sub-header">
                <td>Male</td>
                <td>Female</td>
                <td>Others</td>
              </tr>
            </th>
            <th scope="col" v-if="tableHeader.length > 2">
              <tr class="sub-header">
                <td>Male</td>
                <td>Female</td>
                <td>Others</td>
              </tr>
            </th>
            <th scope="col" v-if="tableHeader.length > 3">
              <tr class="sub-header">
                <td>Male</td>
                <td>Female</td>
                <td>Others</td>
              </tr>
            </th>
            <th scope="col" v-if="tableHeader.length > 4">
              <tr class="sub-header">
                <td>Male</td>
                <td>Female</td>
                <td>Others</td>
              </tr>
            </th>
            <th scope="col" v-if="tableHeader.length > 5">
              <tr class="sub-header">
                <td>Male</td>
                <td>Female</td>
                <td>Others</td>
              </tr>
            </th>
          </tr>
        </thead>
        <tbody class="am-body">
          <tr
            class="rows"
            v-for="(row, key) in rowsData"
            :key="key"
          >
            <td class="row-data pl-2" :title="key">{{key}}</td>
            <td
              class="row-data"
              v-for="(r, index) in row"
              :key="index"
            >
              <tr class="sub-rows">
                <td v-if="r.Male">{{r.Male.toFixed(1)}}</td>
                <td v-else>--</td>
                <td v-if="r.Female">{{r.Female.toFixed(1)}}</td>
                <td v-else>--</td>
                <td v-if="r.Others">{{r.Others.toFixed(1)}}</td>
                <td v-else>--</td>
              </tr>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DiversityDriverTable',

  watch: {
    sortByData: {
      deep: true,
      immediate: true,
      handler () {
        const active = Object.keys(this.sortByData)[0];
        this.activeSort = active;
        // this.onClickSortBy(this.activeSort);
      }
    },
    tableData: {
      deep: true,
      immediate: true,
      handler () {
        this.getDriverRowsData();
      }
    }
  },

  props: {
    tableData: {
      required: true,
      type: Object
    },
    sortByData: {
      required: true,
      type: Object
    }
  },

  data () {
    return {
      sortByItem: 'Location',
      rowsData: [],
      tableHeader: [
        // 'Overall',
        'Carrer Opportunities',
        'Culture', 'Leadership',
        'Performance Management',
        'Rewards and Recognition',
        'Worklife Integration'
      ],
      activeSort: null
    };
  },

  methods: {
    getDriverRowsData () {
      const temp = {};
      const defaultVal = {
        Male: '',
        Female: '',
        Others: ''
      };
      this.$lodash.each(this.tableData, (val, key) => {
        temp[key] = {
          // overall: val.overall ? val.overall : defaultVal,
          carrerOpportunities: val.CareerOpportunities ? val.CareerOpportunities : defaultVal,
          culture: val.Culture ? val.Culture : defaultVal,
          leadership: val.Leadership ? val.Leadership : defaultVal,
          performanceManagement: val.PerformanceManagement ? val.PerformanceManagement : defaultVal,
          rewardsAndRecognition: val.RewardsAndRecognition ? val.RewardsAndRecognition : defaultVal,
          worklifeIntegration: val.WorklifeIntegration ? val.WorklifeIntegration : defaultVal
        };
        // temp.push(val, key);
      });
      this.rowsData = temp;
      // console.log('temp', temp);
    },
    onClickSortBy (type, sortedBy) {
      this.activeSort = type;
      if (sortedBy) {
        this.sortByItem = sortedBy;
      }
      // console.log(this.sortByItem);
      this.$emit('onClickSortByDrivers', type);
    }
  }
};
</script>

<style lang="scss" scoped>
.diversity-driver-table-wrap {
  // background-color: var(--bg-panel);
  overflow-x: auto;
  .top-nav {
    // position: relative;
    padding: 0 12px;
    // background: #584475;
    // background-image: -webkit-gradient(linear,right top, left top,from(transparent),to(rgba(51,148,255,0.18)));
    ul {
      display: flex;
      list-style: none;
      margin: 0;
      padding: 0;
      li {
        position: relative;
        cursor: pointer;
        a {
          text-decoration: none;
        }
        .top-menu {
          // height: 55px;
          height: 48px;
          // border-top-left-radius: 0.375rem;
          border-top-left-radius: 0.5rem;
          // border-top-right-radius: 0.375rem;
          border-top-right-radius: 0.5rem;
          display: flex;
          align-items: center;
          padding-left: 0.5rem;
          padding-right: 0.5rem;
          // margin-right: 0.5rem;
          margin-right: 0.25rem;
          color: var(--color-text);
          // color: var(--bg);
          font-size: var(--content-size);
          position: relative;
          .top-menu__title {
            margin-left: 0.25rem;
            display: flex;
            align-items: center;
            white-space: nowrap;
            .top-menu__sub-icon {
              transition-property: background-color,
              border-color, color, fill, stroke, opacity, box-shadow, transform;
              transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
              transition-duration: 100ms;
              width: 1rem;
              height: 1rem;
              margin-left: 0.5rem;
            }
          }
          &.top-menu--active {
            display: flex;
            // background-color: #faf8fb;
            background-color: var(--bg-panel);
            color: var(--primary-color);
            .top-menu__icon {
              color: var(--primary-dark);;
            }
            .top-menu__title {
              color: var(--color-headings);
              font-weight: var(--heading-weight);
            }
            &::before {
              content: "";
              width: 20px;
              height: 20px;
              margin-left: -20px;
              transform: rotate(90deg) scale(1.04);
              background-size: 100%;
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='259.51' height='259.52' viewBox='0 0 259.51 259.52'%3E%3Cpath id='Path_143' data-name='Path 143' d='M8659.507,423.965c-.167-2.608.05-5.319-.19-8.211-.084-1.012-.031-2.15-.118-3.12-.113-1.25-.1-2.682-.236-4.061-.172-1.722-.179-3.757-.365-5.394-.328-2.889-.478-5.857-.854-8.61-.509-3.714-.825-7.252-1.38-10.543-.934-5.535-2.009-11.312-3.189-16.692-.855-3.9-1.772-7.416-2.752-11.2-1.1-4.256-2.394-8.149-3.687-12.381-1.1-3.615-2.366-6.893-3.623-10.493-1.3-3.739-2.917-7.26-4.284-10.7-1.708-4.295-3.674-8.078-5.485-12.023-1.145-2.493-2.5-4.932-3.727-7.387-1.318-2.646-2.9-5.214-4.152-7.518-1.716-3.16-3.517-5.946-5.274-8.873-1.692-2.818-3.589-5.645-5.355-8.334-2.326-3.542-4.637-6.581-7.039-9.848-2.064-2.809-4.017-5.255-6.088-7.828-2.394-2.974-4.937-5.936-7.292-8.589-3.027-3.411-6.049-6.744-9.055-9.763-2.4-2.412-4.776-4.822-7.108-6.975-3-2.767-5.836-5.471-8.692-7.854-3.332-2.779-6.657-5.663-9.815-8.028-2.958-2.216-5.784-4.613-8.7-6.6-3.161-2.159-6.251-4.414-9.219-6.254-3.814-2.365-7.533-4.882-11.168-6.89-4.213-2.327-8.513-4.909-12.478-6.834-4.61-2.239-9.234-4.619-13.51-6.416-4.1-1.725-8.11-3.505-11.874-4.888-4.5-1.652-8.506-3.191-12.584-4.47-6.045-1.9-12.071-3.678-17.431-5-9.228-2.284-17.608-3.757-24.951-4.9-7.123-1.112-13.437-1.64-18.271-2.035l-2.405-.2c-1.638-.136-3.508-.237-4.633-.3a115.051,115.051,0,0,0-12.526-.227h259.51Z' transform='translate(-8399.997 -164.445)' fill='%23faf8fb'/%3E%3C/svg%3E%0A");
              position: absolute;
              bottom: 0;
              left: 0;
            }
            &::after {
              content: "";
              width: 20px;
              height: 20px;
              margin-right: -20px;
              transform: rotate(180deg) scale(1.04);
              background-size: 100%;
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='259.51' height='259.52' viewBox='0 0 259.51 259.52'%3E%3Cpath id='Path_143' data-name='Path 143' d='M8659.507,423.965c-.167-2.608.05-5.319-.19-8.211-.084-1.012-.031-2.15-.118-3.12-.113-1.25-.1-2.682-.236-4.061-.172-1.722-.179-3.757-.365-5.394-.328-2.889-.478-5.857-.854-8.61-.509-3.714-.825-7.252-1.38-10.543-.934-5.535-2.009-11.312-3.189-16.692-.855-3.9-1.772-7.416-2.752-11.2-1.1-4.256-2.394-8.149-3.687-12.381-1.1-3.615-2.366-6.893-3.623-10.493-1.3-3.739-2.917-7.26-4.284-10.7-1.708-4.295-3.674-8.078-5.485-12.023-1.145-2.493-2.5-4.932-3.727-7.387-1.318-2.646-2.9-5.214-4.152-7.518-1.716-3.16-3.517-5.946-5.274-8.873-1.692-2.818-3.589-5.645-5.355-8.334-2.326-3.542-4.637-6.581-7.039-9.848-2.064-2.809-4.017-5.255-6.088-7.828-2.394-2.974-4.937-5.936-7.292-8.589-3.027-3.411-6.049-6.744-9.055-9.763-2.4-2.412-4.776-4.822-7.108-6.975-3-2.767-5.836-5.471-8.692-7.854-3.332-2.779-6.657-5.663-9.815-8.028-2.958-2.216-5.784-4.613-8.7-6.6-3.161-2.159-6.251-4.414-9.219-6.254-3.814-2.365-7.533-4.882-11.168-6.89-4.213-2.327-8.513-4.909-12.478-6.834-4.61-2.239-9.234-4.619-13.51-6.416-4.1-1.725-8.11-3.505-11.874-4.888-4.5-1.652-8.506-3.191-12.584-4.47-6.045-1.9-12.071-3.678-17.431-5-9.228-2.284-17.608-3.757-24.951-4.9-7.123-1.112-13.437-1.64-18.271-2.035l-2.405-.2c-1.638-.136-3.508-.237-4.633-.3a115.051,115.051,0,0,0-12.526-.227h259.51Z' transform='translate(-8399.997 -164.445)' fill='%23faf8fb'/%3E%3C/svg%3E%0A");
              position: absolute;
              bottom: 0;
              right: 0;
            }
          }
          &:not(.top-menu--active) .top-menu__icon:before {
            content: "";
            z-index: -1;
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            border-top-left-radius: 0.5rem;
            border-top-right-radius: 0.5rem;
            transition-property: background-color,
            border-color, color, fill, stroke, opacity, box-shadow, transform;
            transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
            transition-duration: 100ms;
          }
        }
        @keyframes intro-active-menu-animation {
          100% {
            z-index: 0;
          }
        }
        @keyframes intro-menu-animation {
          100% {
            opacity: 1;
            transform: translateX(0px);
          }
        }
        &:hover .top-menu:not(.top-menu--active) {
          background-color: var(--bg-panel);
          // background-color: var(--bg);
          // background-color: #faf8fb;
          color: var(--primary-color);
        }
        &:hover .dropdown {
          display: block;
        }
        .dropdown {
          list-style: none;
          margin: 0;
          padding: 0.5rem !important;
          // background-color: var(--primary-dark);
          background: rgb(52,43,126);
          background: linear-gradient(150deg, rgba(52,43,126,1) 0%, rgba(84,72,189,1) 70%, rgba(143,72,189,1) 100%, rgba(197,36,55,1) 100%);
          -webkit-box-shadow: 0 3px 20px rgba(0,0,0,.04);
          box-shadow: 0 3px 20px rgba(0,0,0,.04);
          display: none;
          width: 100%;
          position: absolute;
          border-radius: .375rem;
          border-top-left-radius: 0;
          border-top-right-radius: 0;
          z-index: 20;
          li {
            cursor: pointer;
            position: relative;
            .top-menu-side {
              height: 55px;
              border-top-left-radius: 1rem;
              border-top-right-radius: 1rem;
              display: flex;
              align-items: center;
              padding-left: 0;
              padding-right: 0;
              margin-right: 0;
              --text-opacity: 1;
              color: #fff;
              color: rgba(255, 255, 255, var(--text-opacity));
              position: relative;
              width: 100%;
              padding-left: 1.25rem !important;
              .top-menu__title {
                width: 100%;
                margin-left: 0.5rem;
                display: flex;
                align-items: center;
                white-space: nowrap;
                // color: #9f88f1;
                opacity: 0.75;
              }
              // .top-menu__icon:before {
              //   content: "";
              //   z-index: -1;
              //   position: absolute;
              //   width: 100%;
              //   height: 100%;
              //   top: 0;
              //   left: 0;
              //   border-radius: 0.5rem;
              //   transition-property: background-color,
              //   border-color, color, fill, stroke, opacity, box-shadow, transform;
              //   transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
              //   transition-duration: 100ms;
              // }
            }
            &:hover .top-menu-side {
              color: var(--color-text);
              font-weight: var(--heading-weight);
              transition-property: background-color,
              border-color, color, fill, stroke, opacity, box-shadow, transform;
              transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
              transition-duration: 100ms;
            }
            &:hover {
              transition: 0.5s ease;
              .top-menu__title {
                color: var(--bg);
                opacity: 1;
              }
              background-color: rgba(0, 0, 0, 0.04);
            }
          }
        }
      }
    }
  }
  .nav-body {
    padding: 12px;
    background-color: var(--bg-panel);
    .am-table {
      width: 100%;
      border-collapse: collapse;
      border: 2px solid rgba(0,0,0,0.1);
      .am-head {
        .header-row {
          border-bottom: 2px solid rgba(0, 0, 0, 0.1);
          th {
            padding: 0.4rem;
            border-right: 2px solid rgba(0,0,0,0.1);
          }
        }
        .sub-header-row {
          border-bottom: 2px solid rgba(0, 0, 0, 0.1);
          .sub-header {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            td {
              padding: 0.4rem;
            }
          }
          th {
            border-right: 2px solid rgba(0, 0, 0, 0.1);
            padding: 0.4rem;
          }
        }
      }
      .am-body {
        .rows {
          .row-data {
            max-width: 15rem;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          .sub-rows {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            td {
              border: none;
              padding: 0.4rem;
              text-align: center;
            }
          }
          border-bottom: 1px solid #dddddd;
          background-color: var(--bg);
          td {
            border-right: 2px solid rgba(0, 0, 0, 0.1);
          }
        }
      }
    }
  }
}
</style>

<style scoped>
/* @media only screen
  and (max-width: 760px), (min-device-width: 768px)
  and (max-device-width: 1024px)  {
    table, thead, tbody, th, td, tr {
      display: block;
    }
  thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  tr {
    margin: 0 0 1rem 0;
  }
  td {
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 50%;
  }
  td:before {
    position: absolute;
    top: 0;
    left: 6px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
  }
} */
</style>
